import { Component, OnInit,Input } from '@angular/core';
import { GlobalService } from '@common/global';
@Component({
  selector: 'app-ui-tag',
  templateUrl: './ui-tag.component.html',
  styleUrls: ['./ui-tag.component.sass']
})
export class UiTagComponent implements OnInit {
  @Input('a') application: string;
  @Input('c') component: string;
  @Input('tag') tag: object;
  @Input('className') className: string;
  constructor(private _global: GlobalService) { }

  ngOnInit(): void {
  }

}
